import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { AllowedAction } from '@/data/allowedActions'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

interface UserPermission {
  module: string
  allowed_action: AllowedAction[]
}

export function useMyPermissions() {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ApiResponse<{ permissions: UserPermission[] }>>(
    token ? '/api/me/permissions' : null,
    undefined,
    token ?? '',
  )

  const hasPermission = (module: string, action: AllowedAction): boolean => {
    if (!data?.data?.permissions) return false
    return data.data.permissions.some(
      (permission) => permission.module === module && permission.allowed_action.includes(action),
    )
  }

  return {
    permissions: data?.data?.permissions ?? [],
    isLoading: !error && !data,
    isError: error,
    mutate,
    hasPermission,
  }
}
